module.exports = __webpack_public_path__ + "img/footerLogo.5c7b5e6a.png";